import React from 'react';
import DocumentsTableSC from './documents-table.styled';
import { ReactComponent as FileIcon } from '../../../assets/img/svg/pdf.svg';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { EmptySC } from '../../investor-mailbox-content/investor-mailbox-content.styled';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { LS_ACCESS_TOKEN } from '../../../constants';

const DocumentsTable = ({ documents }) => {
  const onDocumentClick = (docLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${docLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
  };

  if (documents.length < 1) {
    return (
      <EmptySC>
        <div className="empty-table">
          <SmallText className="black-transparent bold">
            <FormattedMessage
              id="mailbox_documents_empty"
              defaultMessage={dlt['mailbox_documents_empty']}
            />
          </SmallText>
        </div>
      </EmptySC>
    );
  }

  return (
    <DocumentsTableSC>
      {documents.map((doc) => {
        return (
          <div key={doc.id} className="doc-wrap">
            <button onClick={() => onDocumentClick(doc.url)}>
              <span className="doc-icon">
                <FileIcon />
              </span>
              <div className="doc-info-wrap">
                <span className="doc-name">
                  <BodyText>{doc.display_name ?? doc.name}</BodyText>
                </span>
                <span className="doc-date">
                  <BodyText className="black-transparent">
                    <Moment format="DD. MMMM YYYY">{doc.created_at}</Moment>
                  </BodyText>
                  <BodyText className="black-transparent">
                    <Moment format="HH:mm">{doc.created_at}</Moment>
                  </BodyText>
                </span>
              </div>
            </button>
          </div>
        );
      })}
    </DocumentsTableSC>
  );
};

export default DocumentsTable;
